import {AuthService, OrderService, MovieService} from 'hasta-la-vista-middleware-api/service'
export default {
    name: 'points',

    props: {
        userPoints: Number
    },

    data () {
        return {
            loading: false,
            transactions: {},
            activeTab: null,


        }
    },

    created(){
        this.loading = true;
        OrderService.getTransactionHistory().then((history)=> {
            var points = 0;
            // console.log('history',history);
            this.transactions = history.sort((a,b)=>{
                return ( a.TransactionDate).date.diff(( b.TransactionDate).date) ;
                // a =(a.SessionTime || a.TransactionDate).timestamp;
                // b = (b.SessionTime || b.TransactionDate).timestamp;
                // return a<b ? -1 : a>b ? 1 : 0;
            }).reduce((col, item)=> {
                col[item.year] = col[item.year] || [];
                col[item.year].push(item);
                points = points + (item.PointsEarned - item.PointsRedeemed);
                item.pointsTotal = points;

                return col;

            }, {});

            this.loading = false;
            this.activeTab = Object.keys(this.transactions)[0];
            // console.log(this.transactions);
        })
    },

    computed: {
        activeTabGrouped(){

            return this.transactions[this.activeTab].reduce((col, item)=> {

                col[item.month] = col[item.month] || [];

                col[item.month].push(item);

                return col;

            }, {});
        }
    }
}


// WEBPACK FOOTER //
// ./src/components/profile/points/points.js